import { environment } from 'src/environments/environment'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { Observable, of } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { NotificationService } from 'src/app/core/notification.service'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { ConfigurationOptionService } from '../../configuration-option.service'
import { configurationOptionActions } from '../../configuration-option.actions'
import { Actions, ofType } from '@ngrx/effects'
import { ISO639LanguageCodes } from 'src/app/shared/utils/languageCodes'
@Component({
  selector: 'configuration-option-terms-conditions',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionMTermsConditionsCardComponent
  implements OnInit
{
  @Output() onSubmit = new EventEmitter<any>()
  public formValues$: Observable<any>
  public form: UntypedFormGroup
  public isLoading$: Observable<boolean>
  @Input() isCollapsed: any = false
  //public isCollapsed = false
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )
  public availableLanguageCodes = environment.availableLanguageCodes ?? [
    ISO639LanguageCodes.English
  ]
  public sectionTitle = ['termsAndCondtions']
  public subSectionTitle = {
    termsAndCondtions: {
      name: [
        'general.termsUrl',
        'communicationModule.privacyTermsUrl',
        'communicationModule.biometricTermsUrl',
        'communicationModule.directDebitTermsUrl'
      ],
      formControlName: [
        '_general_terms_url',
        '_privacy_terms_url',
        '_biometric_terms_url',
        '_direct_debit_conditions_link'
      ]
    }
  }
  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    public accessRightService: UserAccessRightService,
    private configOptionService: ConfigurationOptionService,
    private actions$: Actions
  ) {}
  config: any = {
    placeholder: '',
    tabsize: 2,
    dialogsInBody: true,
    height: '200px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'clear'
        ]
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
      'opensans',
      'sansserif',
      'monospace',
      'serif'
    ]
  }

  ngOnInit() {
    this.form = this.fb.group({
      nl_general_terms_url: [null, []],
      en_general_terms_url: [null, []],
      nl_privacy_terms_url: [null, []],
      en_privacy_terms_url: [null, []],
      nl_biometric_terms_url: [null, []],
      en_biometric_terms_url: [null, []],
      nl_terms_conditions_footer: [null, []],
      en_terms_conditions_footer: [null, []],
      nl_direct_debit_conditions_link: [null, []],
      en_direct_debit_conditions_link: [null, []],
      fr_general_terms_url: [null, []],
      de_general_terms_url: [null, []],
      fr_privacy_terms_url: [null, []],
      de_privacy_terms_url: [null, []],
      fr_biometric_terms_url: [null, []],
      de_biometric_terms_url: [null, []],
      fr_terms_conditions_footer: [null, []],
      de_terms_conditions_footer: [null, []],
      fr_direct_debit_conditions_link: [null, []],
      de_direct_debit_conditions_link: [null, []]
    })

    this.formValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )
    this.formValues$.pipe(take(1)).subscribe((formValues) => {
      this.form.patchValue(formValues)
    })

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
  }

  public onFormSubmit(): void {
    if (!this.form.valid) {
      return
    }
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(4000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )

    this.configOptionService.updateOrCreateMany(this.form.value)
  }
}
